import { ChangeEvent, useEffect, useState } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import FeePayerWalletTable, {
  tableColumns
} from 'components/tables/FeePayerWalletTable';
import { errorHandler } from 'helpers/response-utils';
import { parseData } from 'helpers/utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Col, Row } from 'react-bootstrap';
import Button from 'components/base/Button';
import { useNavigate } from 'react-router-dom';
import SearchBox from 'components/common/SearchBox';
const List = () => {
  const nav = useNavigate();
  const [walletList, setWalletList] = useState([]);
  const userJSON = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  const [copySuccess, setCopySuccess] = useState('');

  const handleMakeActive = async (id: string) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_ENDPOINT}/feepayer-wallet/status/active`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      errorHandler(response);

      if (response.data.status === 'success') {
        getWalletList();
      }
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  const table = useAdvanceTable({
    data: walletList,
    columns: tableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      makeActive: handleMakeActive
    }
  });

  useEffect(() => {
    getWalletList();
  }, []);

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const navigateToCreateWallet = () => {
    nav('/feepayer-wallet/generate');
  };

  const getWalletList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/feepayer-wallet`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    errorHandler(response);
    setWalletList(response.data['data']['wallets']);
  };

  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <h2 className="mb-4">{walletList.length} Wallet</h2>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={navigateToCreateWallet}
              >
                Fee Payer Wallet
              </Button>
            </Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Search by name"
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
              </div>
            </Col>
          </Row>
          <FeePayerWalletTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default List;
